module.exports = __webpack_public_path__ + "img/HCA-Horizontal.93fd529f.png";